import React from 'react';
import { MDBBtnFixedItem, MDBCard, MDBCardTitle, MDBCardText, MDBFormInline, MDBBadge, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBCol, MDBBtn, MDBIcon } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import DemonstratorCard from './ComponentFragments/DemonstratorCard';


export default class DemonstratorList extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            flipped: false,
            demonstratorData: [],
            filteredData: [],
            contactStatusSelection: []
        }
        this.handleFlipping = this.handleFlipping.bind(this);
        this.getDemonstratorData = this.getDemonstratorData.bind(this);
        this.searchList = this.searchList.bind(this);
    }

    searchList(phrase) {
        let arr = [];
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        if (TMAUser.data.statusCode1 == 'D') {
            arr = this.state.demonstratorData.filter((dem) => (dem.sfCurrentCode.toUpperCase().includes(phrase.toUpperCase())) || (dem.name.toUpperCase().includes(phrase.toUpperCase())))
        } else {
            arr = this.state.demonstratorData.filter((dem) => (
                dem.sfCurrentCode.toUpperCase().includes(phrase.toUpperCase())) || (dem.name.toUpperCase().includes(phrase.toUpperCase())) || (dem.unitName.toUpperCase().includes(phrase.toUpperCase()))
            )
        }
        this.setState({ filteredData: arr });
    }

    componentDidUpdate(prevProps) {
        var prevParams = prevProps.match.params.opt;
        var currParams = this.props.match.params.opt;
        if (prevParams !== currParams) {
            this.getDemonstratorData();
        }
    }

    async getDemonstratorData() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        if (TMAUser.data.statusCode1 == 'D' || this.props.match.params.opt == "1") {
            await dl.Get('/demonstrator/getmyrecruits', 200).then((response) => {
                this.setState({
                    demonstratorData: response.data,
                    filteredData: response.data
                });
                this.props.loaderOff();
            })
        } else {
            await dl.Get('/common/getunitdemonstrators' + this.props.location.search, 200).then((response) => {
                this.setState({
                    demonstratorData: response.data,
                    filteredData: response.data
                });
                this.props.loaderOff();
            })

        }
    }

    async componentWillMount() {
        this.getDemonstratorData();
    }

    async handleFlipping() {
        if (!this.state.flipped) {
            //var dl = new DataLayer();
            //await dl.Get('/common/getdemonstratorstats?demId=' + this.props.sfId + '&unitId=' + this.props.unitId, 200).then((response) => {
            //    var tttt = "";
            //    this.setState({
            //        extendedData: response.data,
            //        flipped: !this.state.flipped
            //    })

            //})
            this.setState({
                    flipped: !this.state.flipped
                })
        } else {
            this.setState({
                flipped: !this.state.flipped
            })
        }
    }

    render() {
        let headerText = "";
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        if (TMAUser.data.statusCode1 == 'D') {
            headerText = "My Recruits"
        } else {
            headerText = this.props.location.state === undefined || this.props.location.state === null ? "Demonstrators / Recruits" : "Demonstrators For : " + this.props.location.state.detail;
        }
        return (
            <div>
                <Header headerText={headerText}
                    placeholderText={TMAUser.data.statusCode1 == 'D' ? "Search Recruits" : "Search Demonstrators"}
                    searchList={this.searchList}
                />
                <MDBRow>
                    {
                        this.state.filteredData.map((dem) => {
                            return (
                                <MDBCol xl="3" lg="3" md="4" sm="12" className="mb-r" >
                                    <div key={dem.sfId}>
                                    <DemonstratorCard
                                            demName={dem.name.toUpperCase()}
                                            telephoneCell={dem.telephoneCell}
                                            sfCurrentCode={dem.sfCurrentCode}
                                            startWeekId={dem.startWeekId}
                                            endWeekId={dem.endWeekId}
                                            sfId={dem.sfId}
                                            unitId={dem.unitId}
                                            userType={TMAUser.data.statusCode1}
                                            sales={dem.sales}
                                            prevSegSales={dem.prevSegSales}
                                            statusCode={dem.statusCode}
                                            cancelled={dem.cancelled}
                                            recruitId={dem.recruitId}
                                            lastContacted={dem.dateOfContact}
                                            contactStatusId={dem.recruitContactStatusId}
                                            contactStatus={dem.contactStatus}
                                            hasContacted={dem.hasContacted}
                                            opt={this.props.match.params.opt}
                                            statusCode1={TMAUser.data.statusCode1}
                                            channel={dem.channel}
                                            journeyType={dem.journeyType}
                                />
                                </div>
                                </MDBCol>


                            );
                        })
                    }
                </MDBRow>
                

            </div>
        );
    }
}